import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import langM from './lang'
import LoadingComp from '../../../component/LoadingComp'
import localstorage from 'src/helper/localstorage'
import { history } from 'src/core/router'
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: {},
    language:'en',
    userName: '',
    password: '',
    showLoding: true,
    uid: '',
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    // end
    let str = window.location.href.split('?')
    let newkey = null

    if (str[1]) {
      let obj = {}
      let ns = str[1].split('&')
      ns.forEach(item => {
        let i = item.split('=')
        obj[i[0]] = i[1]
      })
      newkey = obj
      console.log(str[1], ns, obj)
      this.getPayInfo(obj.token, obj.PayerID)
    }

  }
  //qu支付
  getPayInfo = async (tokens, order) => {
    let res = await http.post('/withoutsign/paypal/order/capture', { captureId: tokens, order })
    if (res.code == 0) {
      console.log(res.msg)
      /* history.go(-2)  成功 */
      if (res.res.agent == 1) {
        localstorage.set('isRuby',Number(res.res.ruby)+1)
        history.replace(`/app/ruby-agent`)
      }else{
        localstorage.set('appReaStatus',201) //充值成功
        history.replace(`/app/recharge`)
      }
    }
  }
  render() {
    let { lang, showLoding } = this.state
    return <div className="newpaypal" id='newpaypal'>
      <LoadingComp show={showLoding}></LoadingComp>
    </div>
  }
}



// WEBPACK FOOTER //
// src/pages/app/newpaypal/index.js